import { getAdditionalQueryParamsState } from "../helpers";

export const updatePersonalisationParamsReducer = (state, { payload }) => {
  state.personalisationParams = {
    ...payload,
  };
};

export const setAdditionalQueryParamsReducer = (state, { payload }) => {
  state.additionalQueryParams = {
    ...payload,
  };
};

export const updateAdditionalQueryParamsReducer = (state, { payload }) => {
  state.additionalQueryParams = getAdditionalQueryParamsState(
    state.additionalQueryParams,
    payload,
  );
};

export const setNewSearchReducer = (state) => {
  state.isNewSearch = true;
  state.additionalQueryParams = {};
};

export const clearNewSearchReducer = (state) => {
  state.isNewSearch = false;
};
